import PropTypes from "prop-types"
import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"

import css from "./CategoryTree.scss"
import { categoryTreeReducer, fetchCategories } from "./reducer"
import { checkReducerAdded } from "@wrappers/ErrorBoundary/index.js"
import { addRequiredReducers } from "@containers/App/reducer"

import ChildrenItem from "./ChildrenItem"

const DesktopUdp = ({ udpData }) => (
    <ul className={`${css.container}`}>
        {udpData?.length && udpData.map((item, i) => <ChildrenItem item={item} key={i} id={i} />)}
    </ul>
)

const CategoryTree = () => {
    const dispatch = useDispatch()
    useMemo(() => dispatch(addRequiredReducers({ categoryTreeReducer })), [dispatch])

    const { data } = useSelector((state) => checkReducerAdded(state.categoryTreeReducer))

    useEffect(() => {
        if (!data?.length) {
            dispatch(fetchCategories())
        }
    }, [])

    return (
        <div className="smallRegular">
            <DesktopUdp udpData={data} />
        </div>
    )
}

DesktopUdp.propTypes = {
    udpData: PropTypes.array,
}

export default CategoryTree
